// TODO: rm wrong item-type prefixes

const I_DONT_KNOW = [
  {
    option: 'I don’t know',
    //value: 0,
    value: '0',
  },
]

const NO_I_DONT_KNOWS = [
  {
    option: 'No',
    //value: false,
    value: 'false',
  },
  ...I_DONT_KNOW,
]

const YES_NO_I_DONT_KNOWS = [
  {
    option: 'Yes',
    //value: true,
    value: 'true',
  },
  ...NO_I_DONT_KNOWS,
]

const OBJECT_CATEGORIES = [
  { option: 'Area' },
  {
    option: 'Site / Building',
    value: 'Site',
  },
  {
    option: 'Site / Building Component',
    value: 'Site Component',
  },
  {
    option: 'Object / Collection',
    value: 'Object',
  },
  { option: 'Unknown' },
]

const OBJECT_CONDITIONS = [
  {
    option: 'No damage, good condition',
    //value: '1',
    value: 1,
  },
  {
    option: 'Minor damage, fair condition',
    //value: '2',
    value: 2,
  },
  {
    option: 'Moderate damage, poor condition',
    //value: '3',
    value: 3,
  },
  {
    option: 'Severe damage, very bad condition',
    //value: '4',
    value: 4,
  },
  {
    option: 'Collapsed, destroyed',
    //value: '5',
    value: 5,
  },
]

const OBJECT_COUNTS = [
  { option: 'Less than 100' },
  { option: 'Around 100' },
  { option: 'Between 100-500' },
  { option: 'Greater than 500' },
  { option: 'Everything Is in a Pile' },
]

const OBJECT_DAMAGE_PERCENTAGES = [
  { option: 'Major – Everything or >50% broken and/or wet and/or contaminated and/or burned' },
  { option: 'Moderate – Less than half or 25–50% of the objects and/or partially wet and/or partially contaminated and/or partially burned' },
  { option: 'Minor – One fraction or <20% of objects are broken and/or wet and/or contaminated and/or burned' },
  { option: 'Intact' },
]

const OBJECT_DAMAGE_SIGNIFICANCES = [
  ...NO_I_DONT_KNOWS,
  { option: 'Aesthetic' },
  { option: 'Historic' },
  { option: 'Economic' },
  { option: 'Cultural' },
  { option: 'Religious' },
  { option: 'Earthquake' },
  { option: 'Scientific' },
]

const OBJECT_DAMAGE_SOURCES = [
  { option: 'Biological (Pests, Fungus)' },
  { option: 'Collapse of the Building' },
  { option: 'Extreme Physical Force – Bombardment' },
  { option: 'Extreme Physical Force – Earthquake' },
  { option: 'Fire' },
  { option: 'Vandalism' },
  { option: 'Water' },
  { option: 'Water & Mud' },
  { option: 'Water & Contaminants' },
]

const OBJECT_DAMAGE_TYPES = [
  { option: 'Broken' },
  { option: 'Burned' },
  { option: 'Chemical Deposits on Surface' },
  { option: 'Chipping' },
  { option: 'Corrosion / Rust' },
  { option: 'Cracks' },
  { option: 'Deformed' },
  { option: 'Folds' },
  { option: 'Loose or Flaking Paint Layers' },
  { option: 'Loss of Material' },
  { option: 'Soiled / Grimey' },
  { option: 'Soot Deposits on Surface' },
  { option: 'Tears' },
]

const OBJECT_MATERIALS_INORGANIC = [
  { option: 'Ceramics' },
  { option: 'Fired Pottery' },
  { option: 'Glass' },
  { option: 'Metal – Copper-Based' },
  { option: 'Metal – Gold/Silver-Based' },
  { option: 'Metal – Iron-Based' },
  { option: 'Stone' },
  { option: 'Sun-Baked Clay' },
]

const OBJECT_MATERIALS_ORGANIC = [
  { option: 'Feather' },
  { option: 'Ivory / Bone' },
  { option: 'Leather' },
  { option: 'Paper' },
  { option: 'Papyrus' },
  { option: 'Plant material' },
  { option: 'Plastic' },
  { option: 'Shell' },
  { option: 'Textile' },
  { option: 'Wood' },
]

const OBJECT_LOCATION_TYPES = [
  { option: 'Indoors' },
  { option: 'Outdoors' },
]

const OBJECT_LOCATIONS = YES_NO_I_DONT_KNOWS

const OBJECT_RECORDS = YES_NO_I_DONT_KNOWS

const OBJECT_ROOM_FUNCTIONS = [
  { option: 'Display' },
  { option: 'Storage' },
  { option: 'Other' },
]

const OBJECT_TYPES = [
  { option: 'Audio Tape' },
  { option: 'Book' },
  { option: 'Canvas' },
  { option: 'Coins' },
  { option: 'Document' },
  { option: 'DVD/CD' },
  { option: 'Furniture' },
  { option: 'Manuscript' },
  { option: 'Mosaics' },
  { option: 'Painting' },
  { option: 'Pottery' },
  { option: 'Scroll' },
  { option: 'Statue' },
]

const REPORT_INCIDENT_HAZARDS = [
  { option: 'Earthquake' },
  { option: 'Extreme Temperatures' },
  { option: 'Fire (Arson, accident, clearance)' },
  { option: 'Fire (Lightning)' },
  { option: 'Flood' },
  { option: 'Heavy Rains/Drought' },
  { option: 'Human activity/Non military' },
  { option: 'Landmass/Seamass Movement' },
  { option: 'Pollution/industrial hazards' },
  { option: 'Sea Rise' },
  { option: 'Storm- Hurricane, Tornado, Storm winds' },
  { option: 'Tsunami' },
  { option: 'Volcano' },
  { option: 'Warfare/Military Activity' },
]

const REPORT_TYPES = [
  { option: 'Field Report' },
  { option: 'Testing' },
  { option: 'Archive' },
]

const SITE_ARCHITECTURAL_STYLES = [
  { option: 'Vernacular/Traditional' },
  { option: 'Contemporary' },
  { option: 'Indigenous' },
  { option: 'Ancient' },
]

const SITE_CONDITIONS = [
  {
    option: 'No damage, good condition',
    //value: '1',
    value: 1,
  },
  {
    option: 'Minor damage, fair condition',
    //value: '2',
    value: 2,
  },
  {
    option: 'Moderate damage, poor condition',
    //value: '3',
    value: 3,
  },
  {
    option: 'Severe damage, very bad condition',
    //value: '4',
    value: 4,
  },
  {
    option: 'Collapsed, destroyed',
    //value: '5',
    value: 5,
  },
]

const SITE_INTERVENTION_REQUIREMENTS = YES_NO_I_DONT_KNOWS

const SITE_INTERVENTION_TYPES = [
  { option: 'Evacuation' },
  { option: 'Physical Protection' },
  { option: 'Supporting' },
]

const SITE_OWNERSHIPS_CONTROLS = [
  { option: 'Public (Government)' },
  { option: 'Private' },
  { option: 'Unknown' },
  { option: 'Religious authority' },
]

const SITE_PERSONAL_SAFETY_HAZARDS = [
  //{ option: 'None' },
  { option: 'Imminent Structural Collapse/Falling Material' },
  { option: 'Electrical' },
  { option: 'Chemical' },
  { option: 'Unexploded Ordinance/Landmines' },
]

const SITE_PROTECTION_LEVELS = [
  { option: 'International' },
  { option: 'National' },
  { option: 'Local' },
  { option: 'Unprotected' },
  { option: 'UNESCO World Heritage Site' },
]

const SITE_USES = [
  { option: 'Archive' },
  { option: 'Commercial' },
  { option: 'Library' },
  { option: 'Monument/Site' },
  { option: 'Museum' },
  { option: 'Public use (e.g., school, hospital, recreational, office, hotel)' },
  { option: 'Religious' },
  { option: 'Residential' },
  { option: 'Industrial' },
  { option: 'Organization' },
  { option: 'Gallery' },
]

const SITE_COMPONENT_BUTTRESS_DAMAGE_TYPES = [
  { option: 'Collapse' },
  { option: 'Losses/destroyed elements' },
  { option: 'Leaning/mechanical, other structural' },
  { option: 'Breaks/detached elements' },
  { option: 'Cracks/tears' },
  { option: 'Flaking/friable surface' },
  { option: 'Corrosion' },
  { option: 'Mold/mildew' },
  { option: 'Soil/accretions/discoloration' },
  { option: 'Grafitti/vandalism' },
  { option: 'Water' },
]

const SITE_COMPONENT_CONSTRUCTION_TYPES = [
  { option: 'Masonry (e.g. stone, brick, mudbrick)' },
  { option: 'Wood/Timber' },
  { option: 'Concrete' },
  { option: 'Iron/steel frame' },
  { option: 'Other' },
]

const SITE_COMPONENT_DAMAGE_PERCENTAGES = [
  { option: 'None' },
  { option: '1-10%' },
  { option: '10-30%' },
  { option: '30-60%' },
  { option: '60-90%' },
  { option: '90-100%' },
]

const SITE_COMPONENT_DAMAGES = [
  { option: 'None' },
  { option: '1-10%' },
  { option: '10-30%' },
  { option: '30-60%' },
  { option: '60-90%' },
  { option: '90-100%' },
]

const SITE_COMPONENT_FLOOR_COUNTS = [
  { option: '1' },
  { option: '2' },
  { option: '3' },
  { option: '4' },
  { option: 'Other' },
]

const SITE_COMPONENT_FLOOR_FOUNDATION_DAMAGE_TYPES = [
  { option: 'Off foundation' },
  { option: 'Losses/destroyed elements' },
  { option: 'Leaning/mechanical, other structural' },
  { option: 'Breaks/detached elements' },
  { option: 'Cracks/tears' },
  { option: 'Flaking/friable surface' },
  { option: 'Corrosion' },
  { option: 'Mold/mildew' },
  { option: 'Soil/accretions/discoloration' },
  { option: 'Grafitti/vandalism' },
  { option: 'Fire' },
  { option: 'Water' },
]

const SITE_COMPONENT_HORIZONTAL_STRUCTURAL_DAMAGE_TYPES = [
  { option: 'Collapsed' },
  { option: 'Losses/destroyed elements' },
  { option: 'Leaning/mechanical, other structural' },
  { option: 'Breaks/detached elements' },
  { option: 'Cracks/tears' },
  { option: 'Flaking/friable surface' },
  { option: 'Corrosion' },
  { option: 'Mold/mildew' },
  { option: 'Soil/accretions/discoloration' },
  { option: 'Grafitti/vandalism' },
  { option: 'Fire' },
  { option: 'Water' },
  { option: 'Insect' },
]

const SITE_COMPONENT_ROOF_DAMAGE_TYPES = [
  { option: 'Collapsed' },
  { option: 'Losses/destroyed elements' },
  { option: 'Leaning/mechanical, other structural' },
  { option: 'Breaks/detached elements' },
  { option: 'Cracks/tears' },
  { option: 'Leaning/mechanical' },
  { option: 'Flaking/friable surface' },
  { option: 'Corrosion' },
  { option: 'Mold/mildew' },
  { option: 'Soil/accretions/discoloration' },
  { option: 'Grafitti/vandalism' },
  { option: 'Fire' },
  { option: 'Water' },
]

const SITE_COMPONENT_ROOF_TYPES = [
  { option: 'Dome' },
  { option: 'Thatch' },
  { option: 'Flat' },
  { option: 'Sloping' },
  { option: 'Vaulted' },
  { option: 'Other' },
]

const SITE_COMPONENT_STRUCTURAL_ELEMENTS = [
  { option: 'Stone' },
  { option: 'Brick' },
  { option: 'Timber' },
  { option: 'Concrete' },
  { option: 'Steel' },
  { option: 'Composite' },
  { option: 'Ropes' },
  { option: 'Other' },
]

const SITE_COMPONENT_SUB_SURFACE_DAMAGE_TYPES = [
  { option: 'Collapse/off foundation' },
  { option: 'Losses/destroyed elements' },
  { option: 'Breaks/detached elements' },
  { option: 'Cracks/tears' },
  { option: 'Flaking/friable surface' },
  { option: 'Corrosion' },
  { option: 'Mold/mildew' },
  { option: 'Soil/accretions/discoloration' },
  { option: 'Grafitti/vandalism' },
  { option: 'Fire' },
  { option: 'Water' },
]

const SITE_COMPONENT_SURFACE_DAMAGE_TYPES = [
  { option: 'Collapse' },
  { option: 'Losses/destroyed elements' },
  { option: 'Leaning/mechanical' },
  { option: 'Breaks/detached elements' },
  { option: 'Cracks/tears' },
  { option: 'Flaking/friable surface' },
  { option: 'Corrosion' },
  { option: 'Mold/mildew' },
  { option: 'Soil/accretions/discoloration' },
  { option: 'Grafitti/vandalism' },
  { option: 'Fire' },
  { option: 'Water' },
  { option: 'New construction materials' },
]

const SITE_COMPONENT_VERTICAL_STRUCTURAL_DAMAGE_TYPES = [
  { option: 'Collapsed' },
  { option: 'Losses/destroyed elements' },
  { option: 'Breaks/detached elements' },
  { option: 'Cracks/tears' },
  { option: 'Leaning/mechanical' },
  { option: 'Flaking/friable surface' },
  { option: 'Corrosion' },
  { option: 'Mold/mildew' },
  { option: 'Soil/accretions/discoloration' },
  { option: 'Grafitti/vandalism' },
  { option: 'Fire' },
  { option: 'Water' },
]

const SITE_COMPONENT_WINDOWS_DOORS_DAMAGE_TYPES = [
  { option: 'Collapse' },
  { option: 'Losses/destroyed elements' },
  { option: 'Leaning/mechanical' },
  { option: 'Breaks/detached elements' },
  { option: 'Cracks/tears' },
  { option: 'Flaking/friable surface' },
  { option: 'Corrosion' },
  { option: 'Soil/accretions/discoloration' },
  { option: 'Grafitti/vandalism' },
  { option: 'Fire' },
  { option: 'Water' },
]

export default {
  OBJECT_CATEGORIES,
  OBJECT_CONDITIONS,
  OBJECT_COUNTS,
  OBJECT_DAMAGE_PERCENTAGES,
  OBJECT_DAMAGE_SIGNIFICANCES,
  OBJECT_DAMAGE_SOURCES,
  OBJECT_DAMAGE_TYPES,
  OBJECT_LOCATIONS,
  OBJECT_LOCATION_TYPES,
  OBJECT_MATERIALS_INORGANIC,
  OBJECT_MATERIALS_ORGANIC,
  OBJECT_RECORDS,
  OBJECT_ROOM_FUNCTIONS,
  OBJECT_TYPES,
  REPORT_INCIDENT_HAZARDS,
  REPORT_TYPES,
  SITE_ARCHITECTURAL_STYLES,
  SITE_COMPONENT_BUTTRESS_DAMAGE_TYPES,
  SITE_COMPONENT_CONSTRUCTION_TYPES,
  SITE_COMPONENT_DAMAGE_PERCENTAGES,
  SITE_COMPONENT_DAMAGES,
  SITE_COMPONENT_FLOOR_COUNTS,
  SITE_COMPONENT_FLOOR_FOUNDATION_DAMAGE_TYPES,
  SITE_COMPONENT_HORIZONTAL_STRUCTURAL_DAMAGE_TYPES,
  SITE_COMPONENT_ROOF_TYPES,
  SITE_COMPONENT_ROOF_DAMAGE_TYPES,
  SITE_COMPONENT_STRUCTURAL_ELEMENTS,
  SITE_COMPONENT_SUB_SURFACE_DAMAGE_TYPES,
  SITE_COMPONENT_SURFACE_DAMAGE_TYPES,
  SITE_COMPONENT_VERTICAL_STRUCTURAL_DAMAGE_TYPES,
  SITE_COMPONENT_WINDOWS_DOORS_DAMAGE_TYPES,
  SITE_CONDITIONS,
  SITE_INTERVENTION_REQUIREMENTS,
  SITE_INTERVENTION_TYPES,
  SITE_OWNERSHIPS_CONTROLS,
  SITE_PROTECTION_LEVELS,
  SITE_PERSONAL_SAFETY_HAZARDS,
  SITE_USES,
}


// WEBPACK FOOTER //
// ./src/constants/input-options.js